<template>
  <div class="container">
    <div class="handle-box">
      <el-input
        size="small"
        placeholder="输入用户名称"
        v-model.trim="text"
        class="handle-input mr10"
      ></el-input>
      <el-select size="small" v-model="type" class="mr10">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <el-table :data="data.records" border style="width: 100%">
      <el-table-column prop="name" label="用户名称" header-align="center" />
      <el-table-column label="留言内容" align="center" width="330px">
        <template #default="scope">
          <template v-if="scope.row.content.length > 21">
            <el-popover
              placement="top"
              :width="400"
              trigger="hover"
              :content="scope.row.content"
            >
              <template #reference>
                <span>{{ $utils.subString(scope.row.content, 21) }}</span>
              </template>
            </el-popover>
          </template>
          <template v-else>
            {{ scope.row.content }}
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="电话" align="center" />
      <el-table-column
        prop="time"
        label="举报时间"
        width="180"
        align="center"
      />
      <el-table-column label="状态" width="180" align="center">
        <template #default="scope">
          <el-tag v-if="scope.row.status === 0" size="small" type="danger"
            >未读</el-tag
          >
          <el-tag v-if="scope.row.status === 1" size="small" type="success"
            >已阅</el-tag
          >
          <el-tag v-if="scope.row.status === 3" size="small" type="warning"
            >标记</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="240">
        <template #default="scope">
          <el-button
            type="primary"
            size="mini"
            v-if="scope.row.status === 0"
            @click="setStatus(scope.row, 3)"
            >标记</el-button
          >
          <el-button
            type="warning"
            size="mini"
            v-if="scope.row.status === 0"
            @click="setStatus(scope.row, 1)"
            >已阅</el-button
          >
          <el-button
            type="danger"
            v-if="scope.row.status === 1 || scope.row.status === 3"
            size="mini"
            @click="delData(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page="data.current"
        :page-size="20"
        :total="data.total"
        @current-change="getData"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { reactive, ref, toRefs, watch, getCurrentInstance } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import api from "./../../api/index.js";
import NProgress from "nprogress";
export default {
  setup() {
    let text = ref("");
    let type = ref("");
    const { ctx } = getCurrentInstance();
    let options = reactive([
      { label: "全部", value: "" },
      { label: "标记", value: 3 },
      { label: "已阅", value: 1 },
    ]);
    let data = reactive({ data: { records: [] } });
    // 查询数据
    const getData = async (page = 1) => {
      if (text.value.length > 30) {
        ElMessage.warning("搜索内容最多输入30个字");
        return;
      }

      const params = {
        name: text.value,
        status: type.value,
        currentPage: page,
        pageSize: 20,
      };
      try {
        NProgress.start();
        const res = await api.idea.getData(params);
        NProgress.done();
        if (res.code === 10200) {
          data.data = res.data;
        } else {
          ElMessage.error(res.msg);
        }
      } catch (error) {
        NProgress.done();
      }
    };
    watch([text, type], (newVal, oldVal) => {
      getData();
    });
    let loading = false;
    // 修改状态
    const setStatus = async (item, status) => {
      if (!loading) {
        const params = {
          status: status,
          id: item.id,
        };
        try {
          NProgress.start();
          loading = true;
          const res = await api.idea.setStatus(params);
          NProgress.done();
          loading = false;
          if (res.code === 10200) {
            getData(data.data.currentPage);
            ElMessage.success("操作成功！");
          } else {
            ElMessage.error(res.msg);
          }
        } catch (error) {
          NProgress.done();
          loading = false;
        }
      }
    };
    // 删除数据
    const delData = (item) => {
      ElMessageBox.confirm("你确定要删除这条数据吗?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          if (!loading) {
            const params = {
              id: item.id,
            };
            try {
              NProgress.start();
              loading = true;
              const res = await api.idea.delData(params);
              NProgress.done();
              loading = false;
              if (res.code === 10200) {
                getData(data.data.currentPage);
                ElMessage.success("删除成功！");
              } else {
                ElMessage.error(res.msg);
              }
            } catch (error) {
              NProgress.done();
              loading = false;
            }
          }
        })
        .catch(() => {});
    };

    getData();

    return {
      text,
      type,
      options,
      ...toRefs(data),
      setStatus,
      delData,
      getData,
    };
  },
};
</script>

<style lang="scss" scoped>
.handle-input {
  width: 300px;
  display: inline-block;
}

.handle-box {
  margin-bottom: 24px;
}

.copy {
  cursor: pointer;
}
</style>